import React, { FC } from 'react';
import './cancel-plan-modal.scss';

interface CancelPlanModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  resetsAt: string | null;
  isSubmitting: boolean;
  error?: string | null;
}

function formatLongDate(isoString: string): string {
  const date = new Date(isoString);
  const weekday = date.toLocaleDateString('en-GB', { weekday: 'long' });
  const day = date.getDate();
  const month = date.toLocaleDateString('en-GB', { month: 'long' });
  const year = date.getFullYear();

  // ordinal suffix
  const suffix =
    day % 10 === 1 && day !== 11
      ? 'st'
      : day % 10 === 2 && day !== 12
        ? 'nd'
        : day % 10 === 3 && day !== 13
          ? 'rd'
          : 'th';

  return `${weekday} ${day}${suffix} ${month} ${year}`;
}

const CancelPlanModal: FC<CancelPlanModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  resetsAt,
  isSubmitting,
  error,
}) => {
  if (!isOpen) return null;

  const dateLabel = resetsAt
    ? formatLongDate(resetsAt)
    : 'the end of your billing period';

  return (
    <div className='cancel-plan-modal-overlay' onClick={onClose}>
      <div className='cancel-plan-modal' onClick={(e) => e.stopPropagation()}>
        <div className='modal-header'>
          <p className='modal-title'>Cancel your plan</p>
          <button className='close-button' onClick={onClose}>
            <svg
              width='20'
              height='20'
              viewBox='0 0 24 24'
              fill='none'
              stroke='#374562'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <line x1='18' y1='6' x2='6' y2='18' />
              <line x1='6' y1='6' x2='18' y2='18' />
            </svg>
          </button>
        </div>

        <div className='modal-body'>
          <h3 className='body-title'>You're about to cancel your plan</h3>
          <div className='body-text'>
            <p>Your included AI and Human time will last until {dateLabel}.</p>
            <p>
              Your account will be moved to a Trial plan after this date. You'll
              still be able to view any existing projects, but will need to
              switch to a paid plan to continue using your Assistant.
            </p>
            <p>Any top-ups you've already made will last until you use them.</p>
          </div>
        </div>

        <div className='modal-footer'>
          {error && <p className='cancel-error'>{error}</p>}
          <button className='btn-cancel-dismiss' onClick={onClose}>
            Go back
          </button>
          <div className='footer-right'>
            <span className='understand-label'>I understand</span>
            <button
              className='btn-cancel-confirm'
              onClick={onConfirm}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Cancelling...' : 'Cancel my plan'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancelPlanModal;
